import axios from "axios";

const { API_URL } = process.env;

const api = axios.create({
    /* eslint no-undef: 0 */
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json"
    }
});

export default api;
